__turbopack_context__.v({
  "banner": "CookieBanner-module-scss-module__7v4Oca__banner",
  "body": "CookieBanner-module-scss-module__7v4Oca__body",
  "closeBtn": "CookieBanner-module-scss-module__7v4Oca__closeBtn",
  "link": "CookieBanner-module-scss-module__7v4Oca__link",
  "text": "CookieBanner-module-scss-module__7v4Oca__text",
  "title": "CookieBanner-module-scss-module__7v4Oca__title",
  "wrapper": "CookieBanner-module-scss-module__7v4Oca__wrapper",
});
